import BaseApi from "./_base-api";

/**
 * Supplement API
 *
 * @class Api
 * @extends {BaseApi}
 */
class Api extends BaseApi {}

const api = new Api({
	type: "Supplement",
	path: "supplements"
});

export default api;
